import {MultiLang} from "../../../models/multiLang";
import {UserInfo} from "../../../../user/components/user-information/users-info";

export class Authority extends MultiLang {
  public cato: string;
  public receiveEnrollOnEsuorBase: boolean;
  public alternativelyEduCount: number;
  public checkEnrollIinOnReg: boolean;
  public emblem: string;
  public httpAddress: string;
  public httpPort: string;
  public httpsAddress: string;
  public httpsPort: string;
  public userId: number;
  public user: UserInfo;
  public hasCollege: boolean;
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/dictionary/region-education-authorities/dictionary-authority.ts